import { Box, Alert } from '@mui/material';
import OneDriveFolderMapper from '../OneDriveFolderMapper';

const ConfigureStep = ({ mode, level1Items, itemMode, companies, onMappingsChange, onValidChange }) => {
  if (mode === 'existing') {
    return (
      <Box sx={{ py: 2 }}>
        <Alert severity="info">
          Los documentos se importarán a expedientes existentes que coincidan con los nombres de las carpetas.
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      {level1Items.length > 0 ? (
        <OneDriveFolderMapper
          items={level1Items}
          itemMode={itemMode}
          companies={companies}
          onMappingsChange={onMappingsChange}
          onValidChange={onValidChange}
        />
      ) : (
        <Alert severity="warning">
          No se encontraron archivos ni carpetas en la ubicación seleccionada
        </Alert>
      )}
    </Box>
  );
};

export default ConfigureStep;
